(() => {
  const LOCK = 'kox_gift_enforcer_lock_v6';

  function locked() {
    const t = Number(sessionStorage.getItem(LOCK) || 0);
    return Date.now() - t < 1200;
  }
  function lock() {
    sessionStorage.setItem(LOCK, String(Date.now()));
  }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!r.ok) throw new Error('Falha /cart.js');
    return r.json();
  }

  async function removeByKey(key) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    return r.ok;
  }

  function isGift(i) {
    return i && i.properties && i.properties._gift === '1';
  }

  function giftMin(i) {
    const v = Number(i?.properties?._gift_min || 0);
    return Number.isFinite(v) ? v : 0;
  }

  async function enforce() {
    if (locked()) return;

    const cart = await fetchCart();

    // regra do brinde tem que olhar só os itens (não frete, não taxa)
    const subtotal = (cart.items_subtotal_price || 0) / 100;

    const gifts = (cart.items || []).filter(isGift);
    if (!gifts.length) return;

    // remove APENAS os brindes cujo mínimo ficou acima do subtotal atual
    const invalid = gifts
      .filter(it => {
        const min = giftMin(it);
        return min > 0 && min > subtotal;
      })
      .sort((a, b) => giftMin(b) - giftMin(a)); // tira os mais altos primeiro

    if (!invalid.length) return;

    lock();

    for (const it of invalid) {
      if (it?.key) await removeByKey(it.key);
    }

    window.location.reload();
  }

  setInterval(() => {
    enforce().catch(() => {});
  }, 900);
})();